import {
  findPremissionIsCLientRole,
  findPremissionIsCompanyRole,
} from "../Users/Roles/UserSecurityFind";
import { Path } from "react-router-dom";

const permissionMap: { permissions: string[]; route: string }[] = [
  // Dashboard
  { permissions: ["Dashboard.View"], route: "dashboard" },

  // Party
  { permissions: ["Master.Ledger.Party.View"], route: "party/parties" },
  { permissions: ["Master.Group.Party.View"], route: "party/partiesGroup" },

  // Item
  { permissions: ["Master.Item.View"], route: "item/items" },
  {
    permissions: ["Master.Item.Category.View"],
    route: "item/itemCategory",
  },
  { permissions: ["Master.Item.Unit.View"], route: "item/units" },
  {
    permissions: ["Master.Item.Locations.View"],
    route: "item/itemlocations",
  },

  // Sales
  { permissions: ["Voucher.Sales.1.View"], route: "sales/invoices" },
  {
    permissions: ["Voucher.Sales.2.View"],
    route: "sales/proformaInvoices",
  },
  {
    permissions: ["Voucher.Sales.3.View"],
    route: "sales/creditNotes",
  },
  { permissions: ["Voucher.Sales.5.View"], route: "sales/receipts" },
  { permissions: ["Voucher.Sales.4.View"], route: "sales/estimate" },
  { permissions: ["Voucher.Sales.6.View"], route: "sales/order" },
  {
    permissions: ["Master.Ledger.Customer.View"],
    route: "sales/customers",
  },

  // Purchase
  {
    permissions: ["Voucher.Purchase.7.View"],
    route: "purchase/purchaseBill",
  },
  {
    permissions: ["Voucher.Purchase.8.View"],
    route: "purchase/debitNote",
  },
  {
    permissions: ["Voucher.Purchase.10.View"],
    route: "purchase/paymentOut",
  },
  {
    permissions: ["Voucher.Purchase.9.View"],
    route: "purchase/order",
  },
  {
    permissions: ["Master.Ledger.Suppliers.View"],
    route: "purchase/suppliers",
  },

  // Expenses & Income
  { permissions: ["Voucher.Expenses.14.View"], route: "expenses" },
  { permissions: ["Master.Ledger.Expenses.View"], route: "expensesLedger" },
  { permissions: ["Master.Group.Expenses.View"], route: "expensesGroup" },
  { permissions: ["Voucher.Income.15.View"], route: "income" },
  { permissions: ["Master.Ledger.Income.View"], route: "incomeLedger" },
  { permissions: ["Master.Group.Income.View"], route: "incomeGroup" },

  // Journals
  { permissions: ["Voucher.Journals.View"], route: "journals" },

  // Banking
  { permissions: ["Voucher.Contra.13.View"], route: "banking/bankAccounts" },
  {
    permissions: ["Master.Ledger.Bank.View"],
    route: "banking/bankAccounts",
  },
  { permissions: ["Master.Ledger.Cash.View"], route: "banking/cashInHand" },
  {
    permissions: ["BankReconciliation.View"],
    route: "banking/bankReconciliation",
  },
  { permissions: ["Cheque.View"], route: "banking/cheque" },

  // Fixed Asset
  {
    permissions: ["Voucher.Asset.11.View"],
    route: "asset/assetPurchase",
  },

  // Draft
  {
    permissions: [
      "Voucher.Sales.1.View",
      "Voucher.Sales.2.View",
      "Voucher.Sales.3.View",
      "Voucher.Sales.5.View",
      "Voucher.Sales.4.View",
      "Voucher.Sales.6.View",
      "Voucher.Purchase.7.View",
      "Voucher.Purchase.8.View",
      "Voucher.Purchase.10.View",
      "Voucher.Purchase.9.View",
      "Voucher.Expenses.14.View",
      "Voucher.Income.15.View",
      "Voucher.Journal.12.View",
      "Voucher.Contra.13.View",
      "Voucher.Asset.11.View",
    ],
    route: "draft",
  },

  // Registers
  {
    permissions: [
      "Voucher.Sales.1.View",
      "Voucher.Sales.2.View",
      "Voucher.Sales.3.View",
      "Voucher.Sales.5.View",
      "Voucher.Sales.4.View",
      "Voucher.Sales.6.View",
      "Voucher.Purchase.7.View",
      "Voucher.Purchase.8.View",
      "Voucher.Purchase.10.View",
      "Voucher.Purchase.9.View",
      "Voucher.Expenses.14.View",
      "Voucher.Income.15.View",
      "Voucher.Journal.12.View",
      "Voucher.Contra.13.View",
      "Voucher.Asset.11.View",
    ],
    route: "registers",
  },

  // Reports
  {
    permissions: [
      "Report.BalanceSheet.View",
      "Report.P&L.View",
      "Report.TrialBalance.View",
      "Report.CashFlow.View",
      "Report.DebtorsAgeing.View",
      "Report.CreditorsAgeing.View",
      "Report.CustomerOutstanding.View",
      "Report.SupplierOutstanding.View",
      "Report.GeneralLedger.View",
      "Report.FixedAssets.View",
      "Report.BankReconciliation.View",
      "Report.GST.View",
      "Report.TcsTds.View",
    ],
    route: "reports",
  },

  // Master
  { permissions: ["Master.Ledger.View"], route: "master/ledger" },
  { permissions: ["Master.Group.View"], route: "master/group" },

  // Settings
  {
    permissions: [
      "Setting.Company.Info.View",
      "Setting.Company.Details.View",
      "Setting.Company.PaymentTerm.View",
      "Setting.Company.GST.View",
    ],
    route: "settings/companyInfo",
  },
  {
    permissions: [
      "Setting.Voucher.1.View",
      "Setting.Voucher.2.View",
      "Setting.Voucher.3.View",
      "Setting.Voucher.5.View",
      "Setting.Voucher.4.View",
      "Setting.Voucher.6.View",
      "Setting.Voucher.7.View",
      "Setting.Voucher.8.View",
      "Setting.Voucher.10.View",
      "Setting.Voucher.9.View",
      "Setting.Voucher.14.View",
      "Setting.Voucher.15.View",
      "Setting.Voucher.13.View",
      "Setting.Voucher.12.View",
      "Setting.Voucher.11.View",
    ],
    route: "settings/vouchers",
  },
  { permissions: ["Setting.Item.View"], route: "settings/items" },
  {
    permissions: ["Setting.OpeningBalance.View"],
    route: "settings/openingBalance",
  },
  { permissions: ["Setting.Templates.View"], route: "settings/templates" },
  {
    permissions: ["Setting.DefaultLedger.View"],
    route: "settings/defaultLedger",
  },
  {
    permissions: [
      "Setting.TC.1.View",
      "Setting.TC.2.View",
      "Setting.TC.3.View",
      "Setting.TC.5.View",
      "Setting.TC.4.View",
      "Setting.TC.6.View",
      "Setting.TC.7.View",
      "Setting.TC.8.View",
      "Setting.TC.10.View",
      "Setting.TC.9.View",
      "Setting.TC.14.View",
      "Setting.TC.15.View",
      "Setting.TC.13.View",
      "Setting.TC.12.View",
      "Setting.TC.11.View",
    ],
    route: "settings/termsandConditions",
  },
  { permissions: ["Setting.TDS.View"], route: "settings/tds" },
  {
    permissions: ["Setting.Currencies.View"],
    route: "settings/currencies",
  },
  { permissions: ["settings.Lockmonth.View"], route: "settings/lockmonth" },
];

const NavLinkPathIsCompanyRole = (
  clientId: string,
  clientSpecificRole?: boolean
) => {
  let showType: string | Partial<Path> = "";
  if (!clientSpecificRole) {
    for (const entry of permissionMap) {
      if (findPremissionIsCompanyRole(entry.permissions)) {
        showType = entry.route;
        break;
      }
    }
  } else {
    for (const entry of permissionMap) {
      if (findPremissionIsCLientRole(entry.permissions, clientId)) {
        showType = entry.route;
        break;
      }
    }
  }
  return `/books/clients/${clientId}/${showType}`;
};

export default NavLinkPathIsCompanyRole;
